import { useState } from "react";
import { ListenBook, ListenLibrary } from "../pages/Listen";
import { Icon } from "./icons";

/**
 * The phone player, docked to the right edge of the desktop app.
 *
 * Same components as the standalone `/listen` route — the vertical, one-thumb
 * layout is exactly right in a narrow column — but rendered beside the tool
 * rather than instead of it, so starting a listen does not throw away whatever
 * you were doing.
 *
 * Deliberately NOT modal: no backdrop, nothing to dismiss. You are meant to
 * keep working while it plays, which is the whole reason it is a drawer.
 *
 * It lives in the app shell rather than in a route, so navigating between
 * projects never unmounts it — remounting would tear down the <audio> element
 * and stop playback mid-sentence.
 */
export function ListenDrawer({ open, onClose }: { open: boolean; onClose: () => void }) {
  const [bookId, setBookId] = useState<string | null>(null);

  return (
    <aside className={`lst-drawer${open ? " open" : ""}`} aria-hidden={!open}
      aria-label="Listen">
      <div className="lst-drawer-bar">
        <Icon name="play" size={15} />
        <span className="lst-drawer-t">Listen</span>
        <button className="lst-drawer-x" onClick={onClose} title="Close the player" aria-label="Close the player">
          <Icon name="chevron-right" size={16} />
        </button>
      </div>
      {/* Kept mounted while the drawer is closed so playback survives being
          hidden — closing it is putting it away, not stopping it. */}
      <div className="lst-drawer-body">
        {bookId
          ? <ListenBook projectId={bookId} onBack={() => setBookId(null)} inDrawer />
          : <ListenLibrary onOpenBook={setBookId} inDrawer />}
      </div>
    </aside>
  );
}
